import 'babel-polyfill';
import MapTooltipSpot from '@/view/components/pin/MapTooltipSpot.vue';
import Vue from 'vue';
import store from '@/store';
import router from '@/router';

/**
 * ピンを扱うクラス
 */
export default class Pin {

  /**
   * コンストラクタ
   * @param {Object} map 地図オブジェクト
   * @param {Object} icon アイコンオブジェクト
   * @param {Object} center 中心
   * @param {Object} options 描画オプション
   *     以下の形式を想定しています。
   *     {
   *       type: {String} 種別,
   *       iconPosition: {String} アイコン表示位置
   *       zIndex: {Number} z-index,
   *       text: {
   *         content: {String} テキスト内容,
   *         color: {String} テキスト文字色カラーコード,
   *         size: {Number} テキスト文字サイズ（ピクセル単位）
   *       },
   *       tooltip: {
   *         content: {String} 内容,
   *         width: {Number} 幅（ピクセル単位）,
   *         size: {Number} 文字サイズ（ピクセル単位）,
   *         color: {String} 文字色カラーコード,
   *         backgroundColor: {String} 背景色カラーコード,
   *       },
   *     }
   */
  constructor(map, icon, center, options = {}) {
    if (!map || !icon || !center) {
      return;
    }

    this.map = map;
    this.icon = icon;
    this.center = center;
    this.options = options;
    this.type = options.type || 'normal';
    this._listeners = [];

    const param = {
      map: this.map,
      position: new navitime.geo.LatLng(this.center.lat, this.center.lon),
      icon: this.icon,
      zIndex: this.options.z_index || 10,
      iconPosition: this.options.iconPosition ? this.options.iconPosition : navitime.geo.ControlPosition.BOTTOM,
    };
    this._pin = new navitime.geo.overlay.Pin(param);

    if (options && options.events && options.events.length > 0) {
      for (let event of options.events) {
        var closure = function(mapEvent){
          event.func(mapEvent, options);
        }
        this.on(event.type, closure);
      }
    }

    if (this.options.tooltip && this.options.tooltip.spot) {
      return;
    }
    if (this.options.text) {
      this.addText(this.options.text);
    }
    if (this.options.tooltip) {
      this.addTooltip(this.options.tooltip);
    }
  }

  /**
   * ピンを削除します
   */
  destroy() {
    if (this._infoWindow) {
      this.removeInfoWindow();
    }
    this._pin.destroy();
  };

  /**
   * ピンを表示します
   */
  show() {
    this._pin.setVisible(true)
  };

  /**
   * ピンを非表示にします
   */
  hide() {
    this._pin.setVisible(false)
  };

  /**
   * テキスト情報を追加します
   * @param {Object} text テキスト情報
   *       {
   *         content: 内容,
   *         size: 文字サイズ,
   *         color: 文字色,
   *       }
   */
  addText(text) {
    if (!text) {
      return;
    }
    const content = text.content ? text.content : '';
    const size = text.size ? text.size : 12;
    const color = text.color ? text.color : '#fff';
    $(this._pin.div).append(
      `<div class="pin-text" style='z-index:100; position: absolute; top: -${size/2}px; text-align: center; color: ${color}; font-size: ${size}px;'>
        ${content}
      </div>`
    );
  }

  /**
   * テキストを表示します
   */
  showText() {
    $(this._pin.div).find(".pin-text").show();
  }

  /**
   * テキストを非表示にします
   */
  hideText() {
    $(this._pin.div).find(".pin-text").hide();
  }

  /**
   * ツールチップを追加します
   * @param {Object} tooltip ツールチップ情報
   *       {
   *         content: 内容,
   *         width: 幅,
   *         size: 文字サイズ,
   *         color: 文字色,
   *         backgroundColor: 背景色,
   *       }
   */
  addTooltip(tooltip) {
    if (!tooltip) {
      return;
    }
    const content = tooltip.content ? tooltip.content : '';
    const width = tooltip.width ? tooltip.width : 80;
    const size = tooltip.size ? tooltip.size : 12;
    const color = tooltip.color ? tooltip.color : '#fff';
    const backgroundColor = tooltip.backgroundColor ? tooltip.backgroundColor : '#666666';
    // App.vue で、ホバー時にツールチップが表示されるように ntjpin-div クラスと pin-tooltip クラスにスタイルを当てています
    $(this._pin.div).addClass('ntjpin-div');
    $(this._pin.div).append(
      `<div class='pin-tooltip fadeIn' style='z-index: 1000; position: absolute; top: ${size}px; left: -${width/2}px;
        text-align: center; background-color: ${backgroundColor}; padding: 4px; border-radius: 4px;
        font-size: ${size}px; color: ${color}; width: ${width}px;'>
        ${content}
      </div>`
    );
  }

  /**
   * スポット情報のツールチップを追加します
   * @param {Object} tooltip ツールチップ情報
   *       {
   *         content: 内容,
   *         width: 幅,
   *         size: 文字サイズ,
   *         color: 文字色,
   *         backgroundColor: 背景色,
   *       }
   */
  addSpotTooltip(tooltip) {
    if (!tooltip || !tooltip.spot) {
      return;
    }
    const width = tooltip.width ? tooltip.width : 300;
    const height = tooltip.width ? tooltip.width : 70;
    // App.vue で、ホバー時にツールチップが表示されるように ntjpin-div クラスと pin-tooltip クラスにスタイルを当てています
    $(this._pin.div).addClass('ntjpin-div');
    $(this._pin.div).append(
      `<div class='pin-tooltip fadeIn' style='z-index: 1000; position: absolute; left: -${width/2}px;
        text-align: center; padding: 0 4px; border-radius: 4px;
        width: ${width}px; height: ${height}px;'>
        <div id="map-tooltip-spot">
        </div>
      </div>`
    );
    // 地図のツールチップをcomponentから呼び出す
    new Vue({
      el: '#map-tooltip-spot',
      data: {
        customize: store.state.system.customize,
        spot: tooltip.spot,
      },
      router,
      store,
      template: `<c-maptooltip-spot :customize="customize" :spot="spot"/>`,
      components: { 'c-maptooltip-spot': MapTooltipSpot }
    });
  }

  /**
   * ピン画像を非表示にします
   */
  hideImage() {
    $(this._pin.div).find('img').hide();
    $(this._pin.div).css('overflow', 'visible');
  };

  /**
   * ピン画像を非表示にします
   */
  showImage() {
    $(this._pin.div).find('img').show();
    $(this._pin.div).css('overflow', 'visible');
  };

  /**
   * ピンにアニメーションを付加します（CSSアニメーションクラスを付与）
   * @param {String} animation アニメーション種別
   */
  startAnimation(animation) {
    $(this._pin.div).addClass(animation);
  };

  /**
   * ピンのアニメーションを止めます
   * @param {String} animation アニメーション種別
   */
  stopAnimation(animation) {
    $(this._pin.div).removeClass(animation);
  };

  /**
   * 緯度経度を取得します
   * @return {Object} 緯度経度オブジェクト（navitime.geo.LaLng）
   */
  getPosition = function() {
    return this._pin.getPosition();
  };

  /**
   * ドラッグ可能かを変更します
   * @param {Boolean} draggable
   */
  changeDraggable(draggable) {
    return this._pin.setDraggable(draggable);
  };

  /**
   * ピンにイベントをひも付けます
   * @param {String} type イベント名称
   * @param {Function} fn コールバック
   */
  on(type, fn) {
    const listener = navitime.geo.util.addListener(this._pin, type, fn);
    listener.type = type;
    this._listeners.push(listener);
    // カーソルをポインタにします
    this._pin.div.style.cursor = "pointer";
  };

  /**
   * ピンのイベントを解除します
   * @param {String} type イベント名称
   */
  off(type) {
    listeners = [];
    $.each(this._listeners, function(i, listener) {
      if (listener.type === type) {
        navitime.geo.util.removeListener(listener);
        return true;
      }
      listeners.push(listener);
    });
    this._listeners = listeners;
    if (this._listeners.length === 0) {
      $(this._pin.div).css("cursor", "auto");
    }
  };

  /**
   * 種別を取得します
   */
  getType() {
    return this.type;
  }

}
